import { render } from "./EditPencil.vue?vue&type=template&id=d54a3e2a"
import script from "./EditPencil.vue?vue&type=script&setup=true&lang=js"
export * from "./EditPencil.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/Common/Svg/EditPencil.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d54a3e2a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d54a3e2a', __exports__)) {
    api.reload('d54a3e2a', __exports__)
  }
  
  module.hot.accept("./EditPencil.vue?vue&type=template&id=d54a3e2a", () => {
    api.rerender('d54a3e2a', render)
  })

}


export default __exports__